import {Pipe, PipeTransform} from '@angular/core';
import {IAppointment} from '../../models/appointment';

@Pipe({
  name: 'filterAppointmentByDay',
})
export class FilterAppointmentByDayPipe implements PipeTransform {

  transform(appointments: IAppointment[] = [], day: number): IAppointment[] {
    return appointments.filter(item => new Date(item.startDate.date).getDate() === day);
  }

}
